module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am695-e73842c40baaf6b5ed439e6c1189dd47.jpg";